var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"icon":"","to":{ path: `/devices/${_vm.trustId}`, query: { type: `${_vm.device_type}` } }}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(_vm._s('mdi-chevron-right'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }